module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-bar"
    }
  }, [_c('img', {
    staticClass: "logo-dr100",
    attrs: {
      "src": require("../../images/logo-dr100.png")
    },
    on: {
      "click": _vm.goToIndex
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-heading"
  }, [_c('p', {
    staticClass: "heading-wrapper"
  }, [_vm._v("Umów wizytę w "), _c('b', [_vm._v(_vm._s(_vm.$store.facility.name))])])]), _vm._v(" "), (_vm.extraHeading) ? _c('div', {
    staticClass: "extra-heading"
  }, [_c('i', {
    staticClass: "mi mi-arrow-back btn-back",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }), _vm._v(_vm._s(_vm.extraHeading) + "\n    ")]) : (_vm.$store.isPatientLoggedIn) ? _c('div', {
    staticClass: "credentials"
  }, [_c('div', {
    staticClass: "patient-info"
  }, [_vm._v(_vm._s(_vm.$store.patient.name) + " " + _vm._s(_vm.$store.patient.surname))]), _vm._v(" "), _c('button', {
    staticClass: "btn-default btn-outline-blue btn-logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("WYLOGUJ SIĘ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92ab4fe0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = 211
// module chunks = 0